define('views/modules/calendar/calendar/calendar-component/item/calendar-item-sortable-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    // views
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-list',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    // views
    VCalendarItemList
) {

    var VCalendarItemSortableList = VCalendarItemList.extend({
        sortable: {
            group: {
                name: 'items',
                pull: true,
                put: true
            },
            delay: Viewport.width() <= 768 ? 50 : 0,
            ghostClass: 'ghost',
            onAdd: 'onDragAdd',
            onUpdate: 'onOrderChange',
        },

        initialize: function(opt) {
            VCalendarItemSortableList.__super__.initialize.call(this, opt);

            this.listenTo(this.collection, {
                'item:remove': this.removeItem,
            });
        },

        ///////////
        // event //
        ///////////
        removeItem: function(item, render) {
            this.collection.remove(item, { silent: true });
            if (render) {
                this.addAll();
            }
        },

        //////////////
        // sortable //
        //////////////
        // (onAdd) Element is dropped into the list from another list
        onDragAdd: function(e) {
            this.$(e.item).trigger('item:move', {
                collection: this.collection,
                position: e.newIndex,
            });
        },

        // (onUpdate) Changed sorting within list
        onOrderChange: function(e) {
            this.collection.move(e.oldIndex, e.newIndex, { silent: true });
        },
    });

    return VCalendarItemSortableList;
});

